//
//
//
//
//
//
//
//
//
//
//
//

import betting from '~/plugins/betting'

export default {
  data() {
    return {
      systemBetSelection: null,
      systemBetChoices: [],
      loading: true
    }
  },
  watch: {
    selections: function (newVal, oldVal) {
      if (_.size(newVal) != _.size(oldVal)) {
        this.$store.commit('betslip/setError', null)
      }

      if (this.betType == 'system') {
        this.calculateSystemBets()
      }
    }
  },
  computed: {
    stakeSingle: {
      get() {
        //if we have other stakes
        return this.$store.state.betslip.stakeSingle
      },
      set(value) {
        this.$store.commit('betslip/setStakesBatch', value)
        this.$store.commit('betslip/setStakeSingle', value)
      }
    },
    stakeCombi: {
      get() {
        //if we have other stakes
        return this.$store.state.betslip.stakeCombi
      },
      set(value) {
        this.$store.commit('betslip/setStakeCombi', value)
      }
    },
    stakeSystem: {
      get() {
        //if we have other stakes
        return this.$store.state.betslip.stakeSystem
      },
      set(value) {
        this.$store.commit('betslip/setStakeSystem', value)
      }
    },
    betType: {
      get() {
        return this.$store.state.betslip.betType
      },
      set(value) {
        this.$store.commit('betslip/setBetType', value)
      }
    },
    selections() {
      return this.$store.state.betslip.selections
    }
  },
  mounted() {

  },
  methods: {
    changeStake() {
      this.$store.commit('betslip/clearStakes')
    },
    async openSettings() {
      this.$modal.show('modal-settings')
    },
    async clear() {
      this.$store.commit('betbuilder/setProcessingStatus', false)
      this.$store.commit('betbuilder/clear')
      this.$store.commit('betbuilder/setError', null)
      this.$store.commit('betslip/toggleBetslip', false)
      this.$store.commit('betbuilder/setPrecannedId', null)
    },
    async close() {
      
      if(this.processingStatus == 'processing')
        return false;
      this.$store.commit('betbuilder/toggleBetslip', false)
      this.$store.commit('betslip/toggleBetslip', false)

    },
  }
}
